import React from 'react'
import { FarmerDashboardLayout } from '../layouts';
import DashboardImage from '../../application/assets/images/farmerspages/homepage.png'


function FarmerDashboard() {


    return (
        <FarmerDashboardLayout>


            <div className='  '>

                <img src={DashboardImage} alt="" />

            </div>


        </FarmerDashboardLayout>
    )
}

export default FarmerDashboard